import { gql } from 'apollo-angular';

const GET_CATEGORIZATION_SCHEME_STATISTICS = gql`
  query getCategorizationSchemeStatistics(
    $organizationId: Long
    $categorizationSchemeName: String
    $categorizationSchemeId: Long
  ) {
    catalogStatistics(
      organizationId: $organizationId
      categorizationSchemeName: $categorizationSchemeName
      categorizationSchemeId: $categorizationSchemeId
    ) {
      categorizationSchemeStatistics {
        categoriesCount
        productsCount
        productsCrossedCount
        productsNonCrossedCount
      }
    }
  }
`;

export default GET_CATEGORIZATION_SCHEME_STATISTICS;
